/**
 * The colours a promotion is allowed to use.
 *
 * An operator picks a theme by name in the admin panel rather than a hex value.
 * That is the whole point: a colour picker in a settings form eventually
 * produces yellow text on white, or a "sale" that is the same red as an error
 * message, and neither is recoverable without a developer. Five named pairs,
 * each checked against its own foreground, cannot go wrong.
 *
 * `solid` is for a filled band — the strip above the masthead, a full-width
 * banner. `tint` is for a section background that has to sit under body copy,
 * where a saturated fill would make the text unreadable.
 */

export const PROMO_THEMES = {
  sale: {
    solid: 'bg-sale text-white',
    solidMuted: 'text-white/75',
    tint: 'bg-sale-soft text-ink',
    rule: 'bg-sale',
    ink: 'text-sale',
  },
  festive: {
    solid: 'bg-festive text-white',
    solidMuted: 'text-white/75',
    tint: 'bg-festive-soft text-ink',
    rule: 'bg-festive',
    ink: 'text-festive',
  },
  cool: {
    solid: 'bg-cool text-white',
    solidMuted: 'text-white/75',
    tint: 'bg-cool-soft text-ink',
    rule: 'bg-cool',
    ink: 'text-cool',
  },
  gold: {
    solid: 'bg-gold text-white',
    solidMuted: 'text-white/75',
    tint: 'bg-gold-soft text-ink',
    rule: 'bg-gold',
    ink: 'text-gold',
  },
  /** Takes whichever world the surrounding shell is dressed as. */
  accent: {
    solid: 'bg-accent text-white',
    solidMuted: 'text-white/75',
    tint: 'bg-accent-soft text-ink',
    rule: 'bg-accent',
    ink: 'text-accent',
  },
  ink: {
    solid: 'bg-ink text-white',
    solidMuted: 'text-white/70',
    tint: 'bg-shell text-ink',
    rule: 'bg-ink',
    ink: 'text-ink',
  },
};

/** Falls back rather than rendering an unstyled band if a theme name is stale. */
export const promoTheme = (name) => PROMO_THEMES[name] ?? PROMO_THEMES.sale;

export default promoTheme;
